module.exports = __webpack_public_path__ + "img/uploader-drop.d31e997f.svg";